import type * as SchemaTypes from '../../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitIndividualMotivationAssessmentResultMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.SubmitIndividualMotivationAssessmentResultInput;
}>;


export type SubmitIndividualMotivationAssessmentResultMutation = (
  { __typename: 'Mutation' }
  & { submitIndividualMotivationAssessmentResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'SubmitIndividualMotivationAssessmentResultSuccessfulResponse' }
    & { result?: SchemaTypes.Maybe<(
      { __typename: 'AssessmentResult' }
      & IndividualMotivationAssessmentResultFragment
    )> }
  ) }
);

export type IndividualMotivationAssessmentResultFragment = (
  { __typename: 'AssessmentResult' }
  & Pick<SchemaTypes.AssessmentResult, 'id' | 'companyId' | 'userId' | 'moduleInstanceId' | 'courseInstanceId' | 'assessmentRunId' | 'createdAt'>
  & { company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'name'>
  ), user?: SchemaTypes.Maybe<(
    { __typename: 'SuperAdminUser' }
    & Pick<SchemaTypes.SuperAdminUser, 'id' | 'name' | 'email' | 'isSuperAdmin'>
  ) | (
    { __typename: 'TenantUser' }
    & Pick<SchemaTypes.TenantUser, 'id' | 'name' | 'email'>
  )>, moduleInstance?: SchemaTypes.Maybe<(
    { __typename: 'ModuleInstance' }
    & Pick<SchemaTypes.ModuleInstance, 'name'>
  )>, courseInstance?: SchemaTypes.Maybe<(
    { __typename: 'CourseInstance' }
    & Pick<SchemaTypes.CourseInstance, 'name'>
  )>, assessmentRun?: SchemaTypes.Maybe<(
    { __typename: 'AssessmentRun' }
    & Pick<SchemaTypes.AssessmentRun, 'name'>
  )>, result: { __typename: 'AitResult' } | { __typename: 'CardioRespResult' } | { __typename: 'DigitSpanResult' } | { __typename: 'GrowthMindsetResult' } | { __typename: 'InbodyCompositionResult' } | (
    { __typename: 'IndividualMotivationResult' }
    & IndividualMotivationAssessmentResultDataFragment
  ) | { __typename: 'ML360Result' } | { __typename: 'NBackResult' } | { __typename: 'OrganisationalAiReadinessResult' } | { __typename: 'PersonalCopingResult' } | { __typename: 'ProcessingSpeedResult' } | { __typename: 'SartResult' } | { __typename: 'SelfDeterminationResult' } | { __typename: 'SpatialPlanningResult' } | { __typename: 'StrengthResult' } | { __typename: 'TeamResilienceResult' } | { __typename: 'TrainersNotesResult' } | { __typename: 'VisualReactionResult' } }
);

export type IndividualMotivationAssessmentResultDataFragment = (
  { __typename: 'IndividualMotivationResult' }
  & { surveys: Array<(
    { __typename: 'IndividualMotivationSurveyResult' }
    & Pick<SchemaTypes.IndividualMotivationSurveyResult, 'category' | 'question'>
    & { subCategory: SchemaTypes.IndividualMotivationSurveyResult['subcategory'] }
    & { scoring: (
      { __typename: 'LikertScaleResult' }
      & IndividualMotivationLikertScaleResultFragment
    ) | (
      { __typename: 'RatingScaleResult' }
      & IndividualMotivationRatingScaleResultFragment
    ) }
  )>, categoryBreakdowns: Array<(
    { __typename: 'IndividualMotivationCategoryBreakdown' }
    & Pick<SchemaTypes.IndividualMotivationCategoryBreakdown, 'category' | 'maximumPossibleScore' | 'averageScore'>
    & { subcategoryAverages: Array<(
      { __typename: 'IndividualMotivationSubcategoryAverage' }
      & Pick<SchemaTypes.IndividualMotivationSubcategoryAverage, 'subcategory' | 'maximumPossibleScore' | 'averageScore'>
    )> }
  )> }
);

export type IndividualMotivationLikertScaleResultFragment = (
  { __typename: 'LikertScaleResult' }
  & Pick<SchemaTypes.LikertScaleResult, 'type' | 'score' | 'total' | 'label'>
);

export type IndividualMotivationRatingScaleResultFragment = (
  { __typename: 'RatingScaleResult' }
  & Pick<SchemaTypes.RatingScaleResult, 'type' | 'score' | 'minimumValue' | 'maximumValue'>
);

export const IndividualMotivationLikertScaleResultFragmentDoc = /*#__PURE__*/ gql`
    fragment IndividualMotivationLikertScaleResult on LikertScaleResult {
  type
  score
  total
  label
}
    `;
export const IndividualMotivationRatingScaleResultFragmentDoc = /*#__PURE__*/ gql`
    fragment IndividualMotivationRatingScaleResult on RatingScaleResult {
  type
  score
  minimumValue
  maximumValue
}
    `;
export const IndividualMotivationAssessmentResultDataFragmentDoc = /*#__PURE__*/ gql`
    fragment IndividualMotivationAssessmentResultData on IndividualMotivationResult {
  surveys {
    category
    subCategory: subcategory
    question
    scoring {
      __typename
      ... on LikertScaleResult {
        ...IndividualMotivationLikertScaleResult
      }
      ... on RatingScaleResult {
        ...IndividualMotivationRatingScaleResult
      }
    }
  }
  categoryBreakdowns {
    category
    maximumPossibleScore
    averageScore
    subcategoryAverages {
      subcategory
      maximumPossibleScore
      averageScore
    }
  }
}
    ${IndividualMotivationLikertScaleResultFragmentDoc}
${IndividualMotivationRatingScaleResultFragmentDoc}`;
export const IndividualMotivationAssessmentResultFragmentDoc = /*#__PURE__*/ gql`
    fragment IndividualMotivationAssessmentResult on AssessmentResult {
  id
  companyId
  company {
    id
    name
  }
  userId
  user {
    __typename
    ... on TenantUser {
      id
      name
      email
    }
    ... on SuperAdminUser {
      id
      name
      email
      isSuperAdmin
    }
  }
  moduleInstanceId
  moduleInstance {
    name
  }
  courseInstanceId
  courseInstance {
    name
  }
  assessmentRunId
  assessmentRun {
    name
  }
  result {
    __typename
    ... on IndividualMotivationResult {
      ...IndividualMotivationAssessmentResultData
    }
  }
  createdAt
}
    ${IndividualMotivationAssessmentResultDataFragmentDoc}`;
export const SubmitIndividualMotivationAssessmentResultDocument = /*#__PURE__*/ gql`
    mutation SubmitIndividualMotivationAssessmentResult($input: SubmitIndividualMotivationAssessmentResultInput!) {
  submitIndividualMotivationAssessmentResult(input: $input) {
    ... on SubmitIndividualMotivationAssessmentResultSuccessfulResponse {
      result {
        ...IndividualMotivationAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${IndividualMotivationAssessmentResultFragmentDoc}`;
export type SubmitIndividualMotivationAssessmentResultMutationFn = Apollo.MutationFunction<SubmitIndividualMotivationAssessmentResultMutation, SubmitIndividualMotivationAssessmentResultMutationVariables>;

/**
 * __useSubmitIndividualMotivationAssessmentResultMutation__
 *
 * To run a mutation, you first call `useSubmitIndividualMotivationAssessmentResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitIndividualMotivationAssessmentResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitIndividualMotivationAssessmentResultMutation, { data, loading, error }] = useSubmitIndividualMotivationAssessmentResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitIndividualMotivationAssessmentResultMutation(baseOptions?: Apollo.MutationHookOptions<SubmitIndividualMotivationAssessmentResultMutation, SubmitIndividualMotivationAssessmentResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitIndividualMotivationAssessmentResultMutation, SubmitIndividualMotivationAssessmentResultMutationVariables>(SubmitIndividualMotivationAssessmentResultDocument, options);
      }
export type SubmitIndividualMotivationAssessmentResultMutationHookResult = ReturnType<typeof useSubmitIndividualMotivationAssessmentResultMutation>;
export type SubmitIndividualMotivationAssessmentResultMutationResult = Apollo.MutationResult<SubmitIndividualMotivationAssessmentResultMutation>;
export type SubmitIndividualMotivationAssessmentResultMutationOptions = Apollo.BaseMutationOptions<SubmitIndividualMotivationAssessmentResultMutation, SubmitIndividualMotivationAssessmentResultMutationVariables>;